var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.552,
    height: 17.95,
    viewBox: "0 0 22.552 17.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(-330.414 -48.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M734.828,9403.25l9.862-9.861,9.862,9.861",
    transform: "translate(-403 -9344)",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M749.4,9398.319v8.981",
    transform: "translate(-401 -9341.962)",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M749.4,9398.319v8.981",
    transform: "translate(-414 -9341.962)",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeicon1);
export default __webpack_public_path__ + "static/media/homeicon1.f6e508c3d2a3ad723f18b3c2140e95ec.svg";
export { ForwardRef as ReactComponent };